<template>
	<div>
		<div class="TopSearch">
			<FromComm :FromArr="FromArr"></FromComm>
			<div class="btngroup">
				<CommonBtngroup ref="btngroup" :qhide="false" @select="handSearch" @reset="handReset"></CommonBtngroup>
			</div>
		</div>
		<div class="BottomTable">
			<!--  -->
			<Commonbtn v-if="auth.includes('add')" backgroundColor="#FFF" title="新增" fontSize="14px" @btnclick="add"
				:src="require('@/assets/icon/icon-add.png')">
			</Commonbtn>
			<!--  v-if="qx.update" -->
			<Commonbtn v-if="auth.includes('edit')" backgroundColor="#FFF" title="修改" fontSize="14px" @btnclick="update"
				:src="require('@/assets/icon/icon-update.png')" :useAutoOptional="false" :optional="tableCurr == null">
			</Commonbtn>
		</div>
		<!--自定义表格-->
		<div class="custom-table" v-for="(item1,index1) in tableData" :key="index1"
			:class="[tableCurr===item1.ID?'select-table':'']" @click="handCkTable(item1.ID)">
			<div class="table-header" :class="[item1.InvClassName==='神经介入'?'red':'']">
				<span v-if="item1.Year">年度：{{item1.Year}}</span>
				<span v-if="item1.InvClassName">产品线：{{item1.InvClassName}}</span>
				<span v-if="item1.CreatorName"> 创建人：{{item1.CreatorName}}</span>
				<span v-if="item1.CreateTime">创建时间：{{item1.CreateTime.substring(0,10)}}</span>
				<span v-if="item1.UpdaterName">修改人：{{item1.UpdaterName}}</span>
				<span v-if="item1.UpdateTime">修改时间：{{item1.UpdateTime.substring(0,10)}}</span>
			</div>
			<div class="table-title">
				<div class="title-item" v-for="(item,index) in titleList" :key="index">
					{{index+1}}月
				</div>
			</div>
			<div class="table-value">
				<div class="value-item" v-for="(item,index) in titleList" :key="index">
					{{item1[item]}}
				</div>
			</div>
		</div>
		<div class="pagination">
			<Pagination ref="invPagination" type='allColor' :pageSize="query.pageSize"
				@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :total="total">
			</Pagination>
		</div>
		<DialogFrom width="1060px" :title="tableCurr?'修改':'新增'" :OKASCAN="true" :dialogVisible="dialogShow"
			@cancel="cancelEditor" @dialogOK="dialogOKEditor">
			<FromComm :FromArr="FromArrEditor"></FromComm>
		</DialogFrom>
	</div>
</template>

<script>
	import FromComm from '../../../../components/fromComponents/Commfrom/from-comm.vue'
	import CommonBtngroup from '../../../../../../../components/commongroup.vue'
	import Commonbtn from '../../../../../../../components/common-btn.vue'
	import DialogFrom from '../../../../../../../components/dialog-from.vue'
	import Pagination from '../../../../../../../components/pagination.vue'
	import FromArr from '../FormData/FromArr'
	import FromArrEditor from '../FormData/FromArrEditor'
	import {
		InventoryClassList
	} from '@/api/home'
	import {
		GetQuotaCustomerRatioList,
		GetQuotaCustomerRatioInfo,
		AddQuotaCustomerRatio,
		EditQuotaCustomerRatio
	} from '@/api/newsapi'
	export default {
		props: {
			auth: Array
		},
		components: {
			FromComm,
			CommonBtngroup,
			Commonbtn,
			DialogFrom,
			Pagination
		},
		data() {
			return {
				total: 0,
				query: {
					pageIndex: 1,
					pageSize: 5
				},
				titleList: ["JanRatio", "FebRatio", "MarRatio", "AprRatio", "MayRatio", "JunRatio",
					"JulRatio", "AugRatio", "SepRatio", "OctRatio", "NovRatio", "DecRatio"
				],
				dialogShow: false,
				FromArr: [],
				FromArrEditor: [],
				tableCurr: null,
				tableData: []
			}
		},
		mounted() {
			this.FromArr = JSON.parse(JSON.stringify(FromArr))
			this.FromArrEditor = JSON.parse(JSON.stringify(FromArrEditor))
			this.inventoryClassList();
			this.getData();
			console.log(this.auth);
		},
		methods: {
			async getData() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});

				this.query.year = this.FromArr[0].modelvalue;
				
				this.query.invClass = this.FromArr[1].modelvalue;
				
				let {
					code,
					data
				} = await GetQuotaCustomerRatioList(this.query)
				if (code == 0) {
					this.total = data.Count;
					this.tableData = data.data;
				}
				loading.close();
			},
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({})
				if (code == 0) {
					this.FromArr[0].options = []
					this.FromArr[1].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						}
						this.FromArr[1].options.push(obj)
						this.FromArrEditor[1].options.push(obj)
					})
					let date = new Date()
					let yearArr = [
						date.getFullYear() - 1,
						date.getFullYear(),
						date.getFullYear() + 1
					]
					yearArr.map((item, index) => {
						let obj = {
							key: item,
							value: item
						}
						this.FromArr[0].options.push(obj)
						this.FromArrEditor[0].options.push(obj)
					})
				} else {
					this.$message.error('公司加载失败')
				}
			},
			handSearch() {
				this.query.pageIndex = 1;
				this.getData();
			},
			handReset() {
				this.query = {
					pageIndex: 1,
					pageSize: 5
				};
				this.FromArr.map((item, index) => {
					item.modelvalue = '';
				})
				this.getData();
			},
			add() {
				this.dialogShow = true;
			},
			async update() {
				if (!this.tableCurr) {
					this.$message.error('请先选择数据');
					return;
				}
				let {
					code,
					data
				} = await GetQuotaCustomerRatioInfo({
					id: this.tableCurr
				})
				if (code == 0) {
					this.FromArrEditor = this.FromArrEditor.map(item => {
						item.modelValue = data.data[item.key];
						item.modelvalue = data.data[item.key];
						return item;
					})
					console.log(this.FromArrEditor);
					this.dialogShow = true;
					this.$forceUpdate();
				}
			},
			handCkTable(e) {
				this.tableCurr = e == this.tableCurr ? null : e;
			},
			cancelEditor() {
				this.FromArrEditor = this.FromArrEditor.map(item => {
					item.modelValue = undefined;
					item.modelvalue = '';
					return item;
				})
				this.tableCurr = null;
				this.dialogShow = false;
				this.$forceUpdate();
			},
			async dialogOKEditor() {
				let params = {};
				this.FromArrEditor.map(item => {
					params[item.key] = item.modelValue || item.modelvalue
				})
				if (this.tableCurr) {
					params.id = this.tableCurr;
					let {
						code,
						data,
						message
					} = await EditQuotaCustomerRatio(params)
					if (code == 0) {
						this.tableCurr = null;
						this.$message('已修改');
						this.cancelEditor();
						this.handSearch();
					} else {
						this.$message.error(message);
					}
				} else {
					let {
						code,
						data,
						message
					} = await AddQuotaCustomerRatio(params)
					if (code == 0) {
						this.$message('已添加');
						this.cancelEditor();
						this.handSearch();
					} else {
						this.$message.error(message);
					}
				}

			},
			handleCurrentChange(e) {
				this.query.pageIndex = e
				this.getData()
			},
			handleSizeChange(e) {
				this.query.pageSize = e
				this.getData()
			}
		}
	}
</script>

<style lang="less" scoped>
	.TopSearch {
		height: 70px;
		margin: 16px 0px 8px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);

		.btngroup {
			// border: 1px solid #0b65ec;
			position: relative;
			bottom: 20px;
		}
	}

	.BottomTable {
		margin-bottom: 14px;
	}

	.custom-table {
		cursor: pointer;
		user-select: none;
		margin-bottom: 16px;
		box-sizing: border-box;

		.table-header {
			height: 40px;
			background: #00266D;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0px 16px;

			span {
				font-size: 14px;
				font-family: Alibaba PuHuiTi 2.0-55 Regular, Alibaba PuHuiTi 20;
				font-weight: 400;
				color: #FFFFFF;
			}
		}

		.red {
			background: #E71D43;
		}

		.table-title {
			display: flex;

			.title-item {
				flex: 1;
				font-size: 14px;
				font-family: Alibaba PuHuiTi 2.0-55 Regular, Alibaba PuHuiTi 20;
				font-weight: 500;
				color: #333333;
				height: 40px;
				line-height: 40px;
				text-align: center;
				border-bottom: 1px solid #EEEEEE;
				border-right: 1px solid #EEEEEE;
				box-sizing: border-box;
			}

			.title-item:last-child {
				border-right: 0px;
			}
		}

		.table-value {
			display: flex;

			.value-item {
				flex: 1;
				font-size: 14px;
				font-family: Alibaba PuHuiTi 2.0-55 Regular, Alibaba PuHuiTi 20;
				font-weight: 500;
				color: #333333;
				height: 40px;
				line-height: 40px;
				text-align: center;
				border-bottom: 1px solid #EEEEEE;
				border-right: 1px solid #EEEEEE;
				box-sizing: border-box;
			}

			.value-item:last-child {
				border-right: 0px;
			}
		}
	}

	.select-table {
		border: 1px solid #00266D;
	}
</style>